<template>
  <div class="row">
    <div class="col-12">
      <div class="card my-4">
        <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2  mb-4">
          <div
            class="row bg-gradient-info shadow-black border-radius-lg pt-4 pb-3 mb-3"> 
            <h6 class="col text-white text-capitalize ps-3">Participants</h6>
          </div>    
          
          <div
            v-if="this.showAlert"
            :class="[
              'alert',
              this.responseStatusCode == 'success'
                ? 'alert-success'
                : this.responseStatusCode == 'error'
                ? 'alert-danger'
                : this.responseStatusCode == 'pending'
                ? 'alert-warning'
                : 'alert-info',
            ]"
            role="alert"
          >
            <span class="text-alert">{{ this.alertMessage }}</span>
          </div>

          <Loading message="Loading datas" :loading = "loading"/>

          <div v-if="loading == false" class="col-lg-12 position-relative z-index-2 mt-5">
              <div class="row">
                <div class="col-lg-2 col-md-4 col-sm-6">
                  <mini-statistics-card
                    :title="{ text: 'Students', value: this.total_students }"
                    detail=""
                    :icon="{
                      name: 'group',
                      color: 'text-white',
                      background: 'info',
                    }"
                  />
                </div>
                <div class="col-lg-2 col-md-4 col-sm-6 mt-lg-0 mt-4">
                  <mini-statistics-card
                    :title="{ text: 'Unique Students', value: this.total_distinct_students }"
                    detail=""
                    :icon="{
                      name: 'person',
                      color: 'text-white',
                      background: 'info',
                    }"
                  />
                </div>
                <div class="col-lg-2 col-md-4 col-sm-6 mt-lg-0 mt-4">
                  <mini-statistics-card
                    :title="{ text: 'Active', value: this.total_enrollments_active }"
                    detail=""
                    :icon="{
                      name: 'how_to_reg',
                      color: 'text-white',
                      background: 'info',
                    }"
                  />
                </div>
                <div class="col-lg-2 col-md-4 col-sm-6 mt-lg-0 mt-4">
                  <mini-statistics-card
                    :title="{ text: 'Completed', value: this.total_enrollments_completede }"
                    detail=""
                    :icon="{
                      name: 'verified',
                      color: 'text-white',
                      background: 'success',
                    }"
                  />
                </div>
                <div v-if="has_score===true" class="col-lg-2 col-md-4 col-sm-6 mt-lg-0 mt-4">
                  <mini-statistics-card
                    :title="{ text: 'Recovery', value: this.total_recovery }"
                    detail=""
                    :icon="{
                      name: 'priority_high',
                      color: 'text-white',
                      background: 'warning',
                    }"
                  />
                </div>
                <div v-if="has_score===true" class="col-lg-2 col-md-4 col-sm-6 mt-lg-0 mt-4">
                  <mini-statistics-card
                    :title="{ text: 'Reproved', value: this.total_reproved }"
                    detail=""
                    :icon="{
                      name: 'block',
                      color: 'text-white',
                      background: 'danger',
                    }"
                  />
                </div>
                <div class="col-lg-2 col-md-4 col-sm-6 mt-lg-0 mt-4">
                  <mini-statistics-card
                    :title="{ text: 'Pre-registered', value: this.total_enrollments }"
                    detail=""
                    :icon="{
                      name: 'edit_note',
                      color: 'text-white',
                      background: 'danger',
                    }"
                  />
                </div>
              </div>
          </div>
          
          <div v-if="loading == false" class="pb-2 pt-0 mt-0 d-flex justify-content-start gap-4 mb-4">
            <div class="col-6">
              <label class="mt-3">Project</label>
              <select class="form-select form-select-lg" v-model="project" @change="selectedProject">
                <option v-if="projects == null" value="">Charger ... </option>
                <option v-else value="">All projects</option>
                <option v-for="project in projects" :value="project.id" :key="project.id">{{ project.name }}</option>
              </select>
            </div>

            <div class="p-0 d-flex w-100">
              <div class="w-100">
                <label class="mt-3">Filter by status</label>
                <div class="d-flex align-items-center gap-2">
                  <select class="form-select form-select-lg" v-model="searchFilterStatus" @change="getAllenrollments()">
                    <option value="">All status</option>
                    <option v-for="status in statusChoices" :value="status.status" :key="status.status">
                      {{ capitalizeStatusChoices(status.status) }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="p-0 d-flex w-100">
              <div class="w-100">
                <label class="mt-3">Filter</label>
                <div class="d-flex align-items-center gap-2">
                  <input type="text" class="form-control form-control-lg custom-input" v-model="searchFilter" placeholder="Search by Name, Phone or UTM">

                  <div class="d-flex algin-items-end">                      
                    <button @click="getAllenrollments()" class="btn bg-gradient-info my-0">FILTER</button>
                  </div>
                </div>
              </div>
            </div>              
          </div>
          
          <div v-if="showActivateParticipantForm" class="activate-participant-form">
            <div class="d-flex justify-content-center w-100">
              <div class="card w-50 border">
                <div class="card-header pt-3 pb-0">
                    <h4>Activate Participant List</h4>
                </div>

                <div class="alert alert-warning d-flex align-items-center m-4" role="alert">
                  <i class="fs-2 text-alert m-3 bi bi-exclamation-triangle"></i>
                  <div class="text-alert">
                    <p>Upload a CSV file containing the list of participant numbers to be activated.</p>
                  </div>
                </div>

                <div class="card-body">
                  <div class="mt-2">
                    <label for="file" class="form-label">CSV File</label>
                    <div class="input-group input-group-outline">
                      <input id="file" type="file" class="form-control" name="file" placeholder="File">
                    </div>
                  </div>

                  <div class="mx-auto d-flex justify-content-around mt-3">                          
                    <button @click="toggleActivateParticipantForm('cancel')" class="btn mb-0 bg-gradient-danger btn-lg w-40 top-button">Cancel</button>
                    <button @click="activateParticipantList()" class="btn mb-0 bg-gradient-success btn-lg w-40 top-button" :disabled="this.isActivating">Import</button>
                  </div>
                </div>                      
              </div>
            </div>
          </div>
          
          <div v-if="allEnrollments!=null && loading == false" class="card px-0 pb-2">
            
            <div v-if="project != null && project != ''" class="w-100 d-flex justify-content-between align-items-center my-0 px-1">
              <div>
                <h5>Selected: {{ this.project_name }}</h5>
              </div>
              
              <div v-if="project != null" class="d-flex justify-content-end align-items-end gap-3">
                <div class="d-flex flex-column mb-3">
                  <label class="form-label text-sm mb-1">Course</label>
                  <select class="form-select form-select-lg" v-model="selectedCourse" @change="changeSelectedCourse" style="min-width: 320px;">
                    <option v-if="coursesByProject == null" value="">Charger ... </option>
                    <option v-else value="" selected>All courses</option>
                    <option v-for="course in coursesByProject" :value="course.id" :key="course.id">{{ course.name }}</option>
                  </select>
                </div>

                <div class="d-flex gap-2">
                  <router-link
                    :class="selectedCourse && selectedCourse !== '' ? 'btn bg-gradient-info p-2 fs-5' : 'btn bg-gradient-secondary p-2 fs-5 disabled'"
                    style="width: 80px; height: 50px;"
                    :to="selectedCourse && selectedCourse !== '' ? { name: 'Registration Page', params: { id: selectedCourse } } : {}"
                  >
                    <i class="bi bi-person-plus"></i>
                  </router-link>
                  <router-link
                    :class="selectedCourse && selectedCourse !== '' ? 'btn bg-gradient-info p-2 fs-5' : 'btn bg-gradient-secondary p-2 fs-5 disabled'"
                    style="width: 80px; height: 50px;"
                    :to="selectedCourse && selectedCourse !== '' ? { name: 'List Push Batch By User', params: { id: selectedCourse } } : {}"
                  >
                    <i class="bi bi-person-up"></i>
                  </router-link>
                </div>
              </div>
            </div>

            <div v-if="showAlertStatus" :class="['alert', responseStatusCode != 200 ? 'alert-danger': 'alert-success', 'alert-dismissible', 'fade', 'show']" role="alert">
              <span class="text-alert">{{ alertMessage }}</span>
              <button type="button" class="btn-close d-flex align-items-center px-4" data-bs-dismiss="alert" aria-label="Close">
                <i class="bi bi-x fs-3"></i>
              </button>
            </div> 

            <div class="table-responsive p-0">                
              <table class="table table-striped table-hover align-items-center mb-4">
                <thead class="bg-dark">
                  <tr>
                    <th
                      class="text-center text-uppercase text-white text-sm font-weight-bolder opacity-7" wrap="wrap" style="white-space: normal; overflow-wrap: break-word; word-wrap: break-word; width: 9rem;"
                    >
                      Number Inscription                        
                    </th>
                    <th
                      class="text-center text-uppercase text-white text-sm font-weight-bolder opacity-7" wrap="wrap" style="white-space: normal; overflow-wrap: break-word; word-wrap: break-word;  width: 9rem;"
                      >
                      Participant Name                        
                    </th>
                    <th
                      v-for="course in courses"
                      :key="'head-course-' + course.id"
                      class="text-center text-uppercase text-white text-sm font-weight-bolder opacity-7"
                      wrap="wrap"

                      style="white-space: normal; overflow-wrap: break-word; word-wrap: break-word; width: 16rem;"

                    >
                      {{ course.name }}
                    </th>
                    <th
                      class="text-center text-uppercase text-white text-sm font-weight-bolder opacity-7" wrap="wrap" style="white-space: normal; overflow-wrap: break-word; word-wrap: break-word; width: 9rem;"
                    >
                      Options                        
                    </th>                      
                  </tr>
                </thead>
                
                <tbody>
                  <tr v-if="allEnrollments.length > 0" v-for="enrollment in allEnrollments" :key="enrollment.id">
                    <td class="align-middle text-center text-sm">
                      <div class="d-flex px-2 py-1 justify-content-center align-items-center">
                        <div class="d-flex flex-column justify-content-center align-items-center">
                          <h6 class="mb-0 text-sm">{{ enrollment.id }}</h6>
                        </div>
                      </div>
                    </td>

                    <td class="align-middle text-center text-sm" wrap="wrap" style="white-space: normal; overflow-wrap: break-word; word-wrap: break-word;">
                      <div class="d-flex px-2 py-1 justify-content-center align-items-center">
                        <div class="d-flex flex-column justify-content-center align-items-center">
                          <h6 class="mb-0 text-sm text-nowrap">{{ enrollment.phone_number }}</h6>
                          <p class="text-xs text-secondary mb-0">
                            {{ enrollment.name }}
                          </p>
                        </div>
                      </div>
                    </td>

                    <td v-for="c in courses" :key="c.id" class="align-middle text-center" style="white-space: normal; overflow-wrap: break-word; word-wrap: break-word;">
                      <div v-if="cellFor(enrollment, c.id)">
                        <span v-if="cellFor(enrollment, c.id).status == 'active'" class="badge badge-sm bg-gradient-success badge-min-width">{{ cellFor(enrollment, c.id).status }}</span>
                        <span v-else-if="cellFor(enrollment, c.id).status == 'completed'" class="badge badge-sm bg-gradient-success badge-min-width">{{ cellFor(enrollment, c.id).status }}</span>
                        <span v-else-if="cellFor(enrollment, c.id).status == 'initial'" class="badge badge-sm bg-gradient-info badge-min-width">{{ cellFor(enrollment, c.id).status }}</span>
                        <span v-else-if="cellFor(enrollment, c.id).status == 'missing_token'" class="badge badge-sm bg-gradient-info badge-min-width">{{ cellFor(enrollment, c.id).status }}</span>
                        <span v-else-if="cellFor(enrollment, c.id).status == 'recovery'" class="badge badge-sm bg-gradient-warning badge-min-width">{{ cellFor(enrollment, c.id).status }}</span>
                        <span v-else-if="cellFor(enrollment, c.id).status == 'reproved'" class="badge badge-sm bg-gradient-danger badge-min-width">{{ cellFor(enrollment, c.id).status }}</span>
                        <span v-else-if="cellFor(enrollment, c.id).status == 'inactive'" class="badge badge-sm bg-gradient-danger badge-min-width">{{ cellFor(enrollment, c.id).status }}</span>
                        <span v-else-if="cellFor(enrollment, c.id).status == 'pre_registered'" class="badge badge-sm bg-gradient-info badge-participant-status">Pre Registered</span>
                        <span v-else-if="cellFor(enrollment, c.id).status == 'pre_registration_completed'" class="badge badge-sm bg-gradient-info badge-participant-status">Pre Registration Completed</span>
                        <span v-else class="badge badge-sm bg-gradient-info badge-min-width">{{ cellFor(enrollment, c.id).status }}</span>

                        <p class="text-xs text-secondary mb-0 mt-2">
                          {{ formatDate(cellFor(enrollment, c.id).created) }}
                        </p>
                      </div>

                      <span v-else class="text-secondary text-xs font-weight-bold">-</span>
                    </td>

                    <td class="align-middle text-center" style="white-space: normal; overflow-wrap: break-word; word-wrap: break-word;">
                      <router-link 
                        v-bind:title="buttonTitle.info"
                        class="btn bg-gradient-warning my-0 fs-6"
                        style="width: 100px;"
                        :to="{ name: 'Batch Participants Enrollments', params: { id: enrollment.id, project_id: project } }"
                      >
                        <i class="bi bi-person-lines-fill"></i>
                      </router-link>

                    </td>                    
                  </tr>
                  
                  <tr v-else>
                    <td class="text-center text-sm" colspan="9" style="background-color: #F9F9F9;">No data found.</td>
                  </tr>
                </tbody>
              </table>

              <nav v-if="this.total_pages > 1" aria-label="Page navigation example">
                <ul class="pagination justify-content-center">
                  <li v-if="this.page_data_enrollment <= this.total_pages && this.page_data_enrollment > 1" class="page-item">
                    <a @click="decrementPage" class="page-link"><i class="bi bi-chevron-double-left"></i></a>
                  </li>
                  <li class="page-item px-2"><a class="page-link">{{ this.page_data_enrollment }}</a></li>
                  <li v-if="this.total_pages > 1" class="page-item d-flex align-items-center">of</li>
                  <li v-if="this.total_pages > 1" class="page-item px-2" style="margin-left: 0.2%;"><a class="page-link">{{ this.total_pages }}</a></li>
                  <li v-if="this.page_data_enrollment < this.total_pages" class="page-item">
                    <a @click="incrementPage" class="page-link"><i class="bi bi-chevron-double-right"></i></a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>

        <LastUpdateInfo :key="lastUpdateKey" />
      </div>
    </div>
  </div>
</template>

<script>
import {http, http_file, url_from_app_user} from "../http/index";
import Loading from "@/views/components/Loading.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import MiniStatisticsCard from "./components/MiniStatisticsCard.vue";
import { capitalize } from "vue";
import LastUpdateInfo from "./components/LastUpdateInfo.vue";

export default {
  name: "ControUsers",

  components : {
    Loading,
    MaterialButton,
    LastUpdateInfo,
    MiniStatisticsCard,
  },

  computed : {    
    camposPreenchidos() {
      if(this.project !=  false && this.course != false){
        return true;
      }
    }
  },

  data() {
    return {
      course: '',
      loading: true,
      project: '',
      projects : null,
      projectId : null,
      showAlert: false,
      alertMessage: "",
      searchFilter: "",
      searchFilterStatus: "",
      total_pages: null,
      data_course: null,
      selectedProj: true,
      allEnrollments: null,
      showAlertStatus: false,
      viewFilterField: false,
      responseStatusCode: "",
      page_data_enrollment: 1,
      token_user: localStorage.getItem("token"),
            
      buttonTitle:{
        info: "Info student",
        block: "Block student?",
        unlock: "Unblocking student?",
        changeStatus: "Change status"
      },
      
      statusBlock: null,
      enrollment_id: null,
      
      view_secndary_info: false,
      lp_url_from_course: null,
      showLP: false,
      data_api_enrollments_list: null,
      data_api_all_participants: null,
      data_secundary_info: {
        course_info: null,
        project_info: null,
        status_enroll: null,
        sender_enroll: null, 
        inscription_data: null, 
        info_LP: null,
        info_bot: null,
        depositions: null
      },
      total_students: 0,
      total_distinct_students: 0,
      total_enrollments: 0,
      total_enrollments_active: 0,
      total_enrollments_inactive: 0,
      total_enrollments_completede: 0,

      pushBatchIdentifier: "",
      pushBatchFile: "",
      showPushBatchForm: false,
      pushBatches : null,
      showImportContainer : false,

      showPushBathDetails: false,
      pushLines: null,

      isImporting: false,
      isFiltered: false,
      search_content: "",
      
      selectedFields:{},
      list_select_field: [],
      checked:false,
      statusChoices: [],

      isActivating: false,
      showActivateParticipantForm: false,
      participantListFile: "",

      // New Feature Course With Score
      has_score: false,
      total_recovery: 0,
      total_reproved: 0,

      lastUpdateKey: 0,
      courses: [],
      project_name: "",
      coursesByProject: [],
      selectedCourse: "",
    };
  },

  mounted() {
    this.getAllProjects()
  },  

  methods: {
    formatDate(date, time = true) {
      const dateObj = new Date(date);
      const day = dateObj.getDate().toString().padStart(2, "0");
      const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
      const year = dateObj.getFullYear();
      const hours = dateObj.getHours().toString().padStart(2, "0");
      const minutes = dateObj.getMinutes().toString().padStart(2, "0");
      const seconds = dateObj.getSeconds().toString().padStart(2, "0");
      
      if (this.allEnrollments) {
        this.number_enroll = this.allEnrollments.length;
      } else {
        this.number_enroll = 0;
      }
      
      if (!time) {
        return `${year}\-${month}\-${day}`;
      }else{
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
      }
      
    },

    capitalizeStatusChoices(text) {
      return text.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
    },

    incrementPage() {
        this.page_data_enrollment++;
        this.getAllenrollments();
    },

    decrementPage() {
      if (this.page_data_enrollment > 1) {
          this.page_data_enrollment--;
          this.getAllenrollments();
      }
    },

    getAllProjects(){
      let payload = {
        token: this.token_user
      }
      
      http.post('/api/v1/dashboard/list-projects-by-client/', payload)
      .then((response) => (this.projects = response.data.projects))
      .finally(() => {
        this.loading = false;
      });
    },

    selectedProject(){
      this.total_pages = null
      this.page_data_enrollment = 1
      this.selectedCourse = ""
      
      if (this.projectId !== null) {
        this.project = this.projectId          
      }
      
      this.getAllenrollments()

      this.lastUpdateKey += 1;
    },

    async getAllenrollments(){
      this.loading = true
      this.isFiltered = true      

      if (this.projectId !== null) {
        this.project = this.projectId          
      }
      
      if (this.searchFilter != ""){
        if (this.search_content == "") {
          this.search_content = this.searchFilter;
        } else {
          if (!this.search_content.includes(this.searchFilter)) {
            this.search_content = this.search_content + ', ' + this.searchFilter;
          }
        }
      }
      
      if (this.searchFilterStatus != "") {
        if (this.search_content == "") {
          this.search_content = this.searchFilterStatus;
        } else {
          if (!this.search_content.includes(this.searchFilterStatus)) {
            this.search_content = this.search_content + ', ' + this.searchFilterStatus;
          }
        }
      } 
      
      if (this.search_content == "") {
        this.isFiltered = false;
      }

      let payload = {
        token_user: this.token_user,
        project_id: this.project,
        pagination: this.page_data_enrollment,
        filter: this.search_content,
        fields_filter: this.list_select_field
      }
      
      await http.post('/api/v1/dashboard/list-enrollment-from-course-client/', payload)
      .then((response) => {
        this.data_api_enrollments_list = response.data
        this.courses = this.data_api_enrollments_list.courses
        this.project_name = this.data_api_enrollments_list.project_name
        this.coursesByProject = this.data_api_enrollments_list.courses_by_project
        
        this.statusChoices = this.data_api_enrollments_list.status_choices
        this.total_pages = this.data_api_enrollments_list.total_pages
        this.allEnrollments = this.data_api_enrollments_list.enrollments
        this.total_enrollments = this.data_api_enrollments_list.total_enrollments
        this.total_enrollments_active = this.data_api_enrollments_list.total_enrollments_active
        this.total_enrollments_inactive = this.data_api_enrollments_list.total_enrollments_inactive
        this.total_enrollments_completede = this.data_api_enrollments_list.total_enrollments_completede
        this.data_course = this.data_api_enrollments_list.information_course
        this.total_students = this.total_enrollments_active + this.total_enrollments_completede + this.total_enrollments_inactive
        this.total_distinct_students = this.data_api_enrollments_list.total_distinct_students || 0

        // New Feature Course With Score
        if (this.data_api_enrollments_list.has_score === true || this.data_api_enrollments_list.has_score == 1) {
          this.has_score = this.data_api_enrollments_list.has_score
          this.total_recovery = this.data_api_enrollments_list.total_enrollments_recovery
          this.total_reproved = this.data_api_enrollments_list.total_enrollments_reproved

          this.total_students = this.total_students + this.total_recovery + this.total_reproved
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.loading = false
        this.search_content = ""
        this.viewFilterField = true

      });        
    },

    updateSelectedFields(labelId) {
      let selectedId = this.selectedFields[labelId];
      
      if (selectedId === "") {
        delete this.selectedFields[labelId];
      } else {
        this.selectedFields[labelId] = selectedId;
      }
      
      this.list_select_field = Object.entries(this.selectedFields).map(([key, value]) => ({ [key]: value }));
      this.getAllenrollments()
    },

    toggleActivateParticipantForm(action) {
      if (action === 'toggle') {
        this.showActivateParticipantForm = !this.showActivateParticipantForm;
      } 
      else if (action === 'cancel') {
        this.showActivateParticipantForm = false;
      }

      this.participantListFile = "";
      this.alertMessage = ""
      this.showAlert = false
    },

    activateParticipantList() {
      if (document.getElementById('file').files.length === 0) {
        this.showAlert = true
        this.responseStatusCode = "error"
        this.alertMessage = "Please fill in all fields."
        return
      }
        
      this.participantListFile = document.getElementById('file').files[0];
      
      if (this.participantListFile.type !== 'text/csv') {
        this.showAlert = true
        this.alertMessage = "The file selected is not a CSV file."
        this.responseStatusCode = "error"
        this.participantListFile = ""
        document.getElementById('file').value = ""
        return
      }

      let reader = new FileReader()
      reader.onload = (event) => {
          let csvContent = event.target.result
      }
      reader.readAsText(this.participantListFile)

      this.isActivating = true
      this.showAlert = true
      this.alertMessage = "Activating participants. Please wait!"
      this.responseStatusCode = "pending"

      let formData = new FormData()
      formData.append('file', this.participantListFile)
      formData.append('course_id', this.project)

      http_file.post('/api/v1/client/activate-participant-list/', formData)
      .then((response) => {
        this.showAlert = true
        this.alertMessage = response.data.detail
        this.responseStatusCode = "success"
        this.participantListFile = ""
        this.showActivateParticipantForm = false
        document.getElementById('file').value = ""

      })
      .catch((error) => {
        this.showAlert = true
        this.alertMessage = error.response.data.detail
        this.responseStatusCode = "error"
        this.participantListFile = ""
        document.getElementById('file').value = ""
      })
      .finally(() => {
        this.isActivating = false
        this.showActivateParticipantForm = false
        this.getAllenrollments()
      })
    },

    cellFor(row, courseId) {
      return (row.enrollments_by_course || []).find(e => e.id === courseId) || null;
    },

    changeSelectedCourse() {
    },
  }
}
</script>

<style scoped>
  .text-alert{
    color: #FFF;
  }

  .form-select {
    background-position: right 18px center
  }
  
  .form-select:focus-visible{
    font-weight: bold;
    border: 1px solid #d2d6da
  }

  .custom-input {
      border: 1px solid #ced4da;
      border-radius: 5px;
      padding-left: 10px;
  }

  .custom-input:focus,
  .custom-input:active {
      border-color: #6c757d;
  }
  .activate-participant-form {
    margin-bottom: 20px;
  }
  .badge-participant-status {
    display: initial;
  }
  
  .badge-min-width {
    min-width: 180px;
    display: inline-block;
  }
</style>